import { render, staticRenderFns } from "./Longrange.vue?vue&type=template&id=0b84a002&"
import script from "./Longrange.vue?vue&type=script&lang=js&"
export * from "./Longrange.vue?vue&type=script&lang=js&"
import style0 from "./Longrange.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports